import { LayoutReducerPropsType } from '@/models/globalModels';

import * as t from '../types';

const globalState: LayoutReducerPropsType = {
  itemActive: [],
  layoutActive: false,
};

export type PossibleActions = { type: 'ACTIVE_ITEM'; payload: string[] } | { type: 'ACTIVE_LAYOUT'; payload: boolean };

const reducer = (state = globalState, action: PossibleActions): LayoutReducerPropsType => {
  /* Develop Log */ // console.log("[Layout Reducer] Action => ", action);
  switch (action.type) {
    case t.ACTIVE_ITEM:
      return {
        ...state,
        itemActive: action.payload,
      };
    case t.ACTIVE_LAYOUT:
      return {
        ...state,
        layoutActive: action.payload,
      };
    default:
      return {
        ...state,
      };
  }
};

export default reducer;
